@let cta = ctaData();
@let article = data();
@let imageDataValue = imageData();

<section
  (click)="onCardClick()"
  (keyup.enter)="onCardClick()"
  [attr.tabindex]="cta && theme() !== PromoTheme.FULL_BG ? 0 : null"
  [class.promo-cta]="theme() !== PromoTheme.FULL_BG && cta"
  class="promo-card relative fill grow no-underline overflow-hidden flex flex--column-reverse flex--space-between"
  [class.white-bg]="theme() === PromoTheme.WHITE"
  [class.surface-primary]="theme() === PromoTheme.WHITE"
  [class.nordic-blue-900-bg]="theme() === PromoTheme.BLUE"
  [class.surface-contrast]="theme() === PromoTheme.BLUE || theme() === PromoTheme.BLACK"
  [class.black-bg]="theme() === PromoTheme.BLACK"
  [class.white-text]="theme() !== PromoTheme.WHITE"
  [class.text-icon-reversed]="theme() !== PromoTheme.WHITE"
  [class.nordic-blue-900-text]="theme() === PromoTheme.WHITE"
  [class.text-icon-primary]="theme() === PromoTheme.WHITE"
  [class.border]="theme() === PromoTheme.WHITE && !(theme() === PromoTheme.WHITE && imageDataValue && !isDouble())"
  [class.full-width]="fullWidth()"
  data-testid="promo-card-container"
>
  @if (article) {
    <section
      class="pr-small no-decoration fill promo-card-content flex flex--column flex--space-between flex-1"
      data-testid="promo-card-text-container"
      [class.z1]="isTextOnTop()"
    >
      <div>
        <div
          class="flex mr-clear-y ps-small-b promo-card-heading"
          data-testid="promo-card-heading"
          [class.ps-small-b]="!price()"
        >
          @if (article?.localSettings?.iconName) {
            <fcom-icon
              class="icon-medium ms-xsmall-r"
              [category]="article?.localSettings?.iconCategory ?? IconLibrary.SVG_LIBRARY"
              [name]="article?.localSettings?.iconName"
            />
          }

          <fcom-heading-tag
            data-testid="heading-tag"
            [level]="headerLevel(article.subjectTaxonomyTags || []) ?? DEFAULT_HEADER_LEVEL"
            [extraClasses]="headerFontLevel(article.subjectTaxonomyTags || []) ?? null"
          >
            {{ article.title || article.teaserTitle }}
          </fcom-heading-tag>
        </div>
        <span class="promo-card-teaser" [innerHTML]="article.teaserText"></span>
      </div>

      @if (isProductPromo() && (price() || originalPrice())) {
        <div class="flex flex--middle">
          @if (!originalPrice() && pricePrefix()) {
            <span class="font-body-2 ms-xxsmall-r font-body-small">{{ pricePrefix() }}</span>
          }
          @if (originalPrice()) {
            <span
              class="heather-700-text text-icon-primary font-heading-4 font-title-medium"
              data-testid="promo-card-product-price"
            >
              {{ price() | finPrice }}
            </span>
          }
          <div class="flex flex--middle">
            <span
              [ngClass]="{
                'font-body-1 font-body-medium ps-xsmall-l strike-through': originalPrice(),
                'font-heading-4 font-title-medium': !originalPrice(),
                'ps-xxsmall-r': aviosPrice(),
              }"
              class="promo-card-product-original-price"
              data-testid="promo-card-product-original-price"
              >{{ originalPrice() ?? price() | finPrice }}</span
            >
            @if (aviosPrice()) {
              <span
                class="font-body-1 medium-type flex flex--middle font-label-medium"
                data-testid="product-card-avios-price"
              >
                /
                <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                {{ aviosPrice() }}
                {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
              </span>
            }
          </div>

          @if (originalPrice() && fullWidth() && !isMobile()) {
            <fcom-tag [theme]="TagTheme.POPULAR" class="ps-xsmall-l" data-testid="promo-card-campaign-tag-full-width">
              <fcom-icon class="icon-small ms-xsmall-r" [name]="SvgLibraryIcon.DISCOUNT_BLOCK" />
              {{ 'campaign.badge' | finLocalization }}
            </fcom-tag>
          }
        </div>
      }

      @if (cta) {
        <div class="ps-medium-t promo-card-cta" [ngClass]="!isProductPromo() ? 'flex flex--end' : ''">
          @if (cta?.url?.includes('auth.finnair.com') && (cta?.url?.includes('login') || cta?.url?.includes('join'))) {
            <fcom-button
              [text]="cta?.title"
              [theme]="
                PromoTheme.WHITE === theme()
                  ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                  : PromoTheme.FULL_BG === theme()
                    ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
                    : ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER
              "
              (clickBtn)="cta?.url?.includes('login') ? openLoginDialog($event) : openJoinDialog($event)"
            />
          } @else {
            <fcom-button
              [text]="cta?.title"
              [theme]="
                cta?.theme ??
                (PromoTheme.WHITE === theme()
                  ? ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                  : PromoTheme.FULL_BG === theme()
                    ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
                    : ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER)
              "
              [href]="cta?.url"
              [size]="cta?.size ?? ButtonSize.MEDIUM"
              [icon]="cta?.icon"
              [externalLink]="cta?.url?.startsWith('http')"
              [openInNewTab]="cta?.openInNewTab"
              (clickBtn)="$event.preventDefault()"
              [loading]="cta?.status === ButtonState.UPDATING"
              [mode]="isProductPromo() ? ButtonMode.FILL : ButtonMode.INLINE"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
            />
          }
        </div>
      }
    </section>
  }
  @if (imageDataValue) {
    <section
      [class.full-image]="theme() === PromoTheme.FULL_BG"
      [class.promo-image]="theme() !== PromoTheme.FULL_BG && !isProductPromo()"
      [class.product-promo-image]="isProductPromo()"
      class="relative fill overflow-hidden"
    >
      @if ((!fullWidth() || isMobile()) && originalPrice()) {
        <fcom-tag
          [theme]="TagTheme.POPULAR"
          class="ps-xsmall-l absolute promo-tag"
          data-testid="promo-card-campaign-tag"
        >
          <fcom-icon class="icon-small ms-xsmall-r" [name]="SvgLibraryIcon.DISCOUNT_BLOCK" />
          {{ 'campaign.badge' | finLocalization }}
        </fcom-tag>
      }
      @if (!imageDataValue.error) {
        <fcom-lqip-image
          class="fill"
          [fillParent]="true"
          [imageData]="imageDataValue"
          [alt]="imageDataValue.alt"
          [ratio]="aspectRatio()"
          [scale]="true"
        />
      }
    </section>
  }
</section>
